// extracted by mini-css-extract-plugin
export var LargeScreenBanner = "ImageCopyBlock-module--LargeScreenBanner--b7cba";
export var banner = "ImageCopyBlock-module--banner--1f12c";
export var content = "ImageCopyBlock-module--content--43d70";
export var cta = "ImageCopyBlock-module--cta--12bf8";
export var ctaLeft = "ImageCopyBlock-module--ctaLeft--75cd8";
export var halfheaderimage = "ImageCopyBlock-module--halfheaderimage--747e0";
export var heading = "ImageCopyBlock-module--heading--302aa";
export var image = "ImageCopyBlock-module--image--1ff6c";
export var imageCta = "ImageCopyBlock-module--imageCta--c98c8";
export var main = "ImageCopyBlock-module--main--b0e5a";
export var para = "ImageCopyBlock-module--para--941ff";
export var smalllScreenBanner = "ImageCopyBlock-module--smalllScreenBanner--55881";
export var subheadline = "ImageCopyBlock-module--subheadline--f7ce3";
export var textContent = "ImageCopyBlock-module--textContent--d04ef";